import { AutogenModelServicefail, AutogenRowServicefail } from "./autogen/AutogenModelServicefail";

export class ModelServicefail extends AutogenModelServicefail<RowServicefail> {
    constructor() {
        super(RowServicefail);
    }
}

export class RowServicefail extends AutogenRowServicefail {
}